// Lives in its own module so the nested dashboard components can read the ids without importing
// back into SummaryDashboard.tsx, which imports them.
export const SUMMARY_DASHBOARD_TEST_IDS = {
  componentCard: 'summary-dashboard-component-card',
  componentCardPlaceholder: 'summary-dashboard-component-card-placeholder',
  componentCardTitle: 'summary-dashboard-component-card-title',
  dataError: 'summary-dashboard-data-error',
  emptyState: 'summary-dashboard-empty-state',
  grid: 'summary-dashboard-grid',
  promptBar: 'summary-dashboard-prompt-bar',
  promptBarCollapsed: 'summary-dashboard-prompt-bar-collapsed',
  promptError: 'summary-dashboard-prompt-error',
  promptInput: 'summary-dashboard-prompt-input',
  promptSubmitButton: 'summary-dashboard-prompt-submit-button',
  promptSubmitHint: 'summary-dashboard-prompt-submit-hint',
  root: 'summary-dashboard',
  templateRow: 'summary-dashboard-template-row',
  templateTile: 'summary-dashboard-template-tile',
  templateTileDescription: 'summary-dashboard-template-tile-description',
  templateTilePreview: 'summary-dashboard-template-tile-preview',
  templateTileTitle: 'summary-dashboard-template-tile-title',
  totalsCard: 'summary-dashboard-totals-card',
  totalsCardChange: 'summary-dashboard-totals-card-change',
  totalsCardEmpty: 'summary-dashboard-totals-card-empty',
  totalsCardError: 'summary-dashboard-totals-card-error',
  totalsCardLabel: 'summary-dashboard-totals-card-label',
  totalsCardLoading: 'summary-dashboard-totals-card-loading',
  totalsCardPercentChange: 'summary-dashboard-totals-card-percent-change',
  totalsCardValue: 'summary-dashboard-totals-card-value',
};
